/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Dashboard } from '../models/Dashboard';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DashboardService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get various statistics calculated from applications in the DB.
     * @returns Dashboard OK
     * @throws ApiError
     */
    public getDashboardStatistics(): CancelablePromise<Dashboard> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/Dashboard',
        });
    }
}
